export default "__VITE_ASSET__50508e5a__"